export default __webpack_public_path__ + "static/media/virt.07b8aa22.png";